<template>
  <a-modal
      :title="modeTitle"
      :maskClosable="false"
      :width="640"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :cancelText="'取消'"
      :okText="'确定'"
      @ok="handleSubmit"
      @cancel="handleCancel"
  >
    <a-form layout="horizontal" :form="form">
      <!-- 角色名字 -->
      <a-form-item label="角色名称" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-input
            type="text"
            placeholder="请输入"
            v-decorator="[
            'roleName',
            {rules: [{ required: true, message: '请输入角色名称' }]}
          ]"
        />
      </a-form-item>

      <!-- 角色描述-->
      <a-form-item label="角色描述" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-input
            type="text"
            placeholder="请输入"

            v-decorator="[
            'roleDesc',
            {rules: [{ required: true, message: '请输入角色描述' }]}
          ]"
        />
      </a-form-item>

      <!-- 选择拥有权限-->
      <a-form-item label="拥有权限" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">

        <a-tree
            :treeData="allPermissionList"
            checkable
            multiple
            v-model="selectTreeKey"
            defaultExpandAll
            @check="this.onCheck"
            v-decorator="[
            'permIds',
            {rules: [{ required: false, message: '请选择拥有权限' }],
             initialValue: '123'}
          ]"
        />
        <div class="check-tree-value" v-if="commitFlag==true">请选择拥有权限</div>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
  import role from "../../api/role";
  import permission from "../../api/permission";
  import {analysisAddress} from "../../utils/address";

  export default {
    name: "RoleFormModal",
    props: [],
    data() {
      return {
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this),
        isAdd: true,
        roleId: "",
        updateData: {},
        allPermissionList: [],//下拉选择全部权限的集合
        selectTreeKey: [],//展示选择树的key的集合
        selectTreeKeys:[],//备份展示选择树的key的集合
        commitFlag: false,//是否能提交
        modeTitle: '',//弹框的标题
        roleReqList: null, //权限上传请求list入参
      };
    },
    methods: {
      //-------------------------------tree组件数据回显-strat---------------------------//
      //获取tree组件能够解析的数据
      getSortTree(list){
        var listCopy = JSON.parse(JSON.stringify(list));
        for(let i in list){
          let key = list[i]
          //判断当前的value是否需要删除
          //找到当前KEY对应的目标节点  {父节点，当前节点}
          let targetDom = this.getTargetDom(key);
          //如果该目标的节点没有父节点，就不就行删除操作
          if(!targetDom.fatherObj.id) continue;

          //把目标节点的兄弟节点抽成单独的list
          let brothersList = [];
          targetDom.fatherObj.children.map(dom=>{
            brothersList.push(dom.id);
          })

          //是否删除父节点
          let isDeleteFather = this.isDeleteFather_fun(brothersList,listCopy);

          //删除节点
          if(isDeleteFather){
            //找到list里面父节点的下标
            targetDom.obj.fatherList.map(father=>{
              let fatherIndex = listCopy.indexOf(father.toString());
              //删除
              if(fatherIndex != -1){
                listCopy.splice(fatherIndex,1);
              }
            })
          }
        }
        return listCopy
      },

      //是否删除父节点
      isDeleteFather_fun(brothersList,list){
        for(let i in brothersList){
          if(list.indexOf(brothersList[i].toString()) == -1){
            return true;
            break;
          }
        }
        return false;
      },

      //找到当前KEY对应的目标节点
      getTargetDom(key){
        let res = {};
        //递归找到对应的节点
        let _getBrothersFun = (list,key,fatherObj = {})=>{
          list.map(obj=>{
            //保存tree上每一条分支的所有的父节点
            fatherObj.fatherList = fatherObj.fatherList ? fatherObj.fatherList : [];
            obj.fatherList = JSON.parse(JSON.stringify(fatherObj.fatherList))
            obj.fatherList.push(obj.parentId);
            if(obj.children && obj.children.length > 0){
              _getBrothersFun(obj.children,key,obj)
            }
            if(key == obj.id){
              res.fatherObj = fatherObj ? fatherObj : null;
              res.obj = obj;
            }
          })
        }
        _getBrothersFun(this.allPermissionList,key)
        return res;
      },
      //-------------------------------tree组件数据回显-end---------------------------//

      //初始化，显示
      init(type, params) {
        this.visible = true;
        this.isAdd = false;
        this.modeTitle ='修改角色'
        this.selectTreeKey = []
        //初始化form表单数据
        if (params) {
          this.updateData = params;
          let formData = {};
          formData.roleName = params.roleName;
          formData.roleDesc = params.roleDesc;
          this.selectTreeKey = params.permIds&&params.permIds.length > 0 ? params.permIds.map(String) : [];
          this.selectTreeKeys = params.permIds&&params.permIds.length > 0 ? params.permIds.map(String) : [];
          //把回显的数据拼接成一棵树
          this.selectTreeKey = this.getSortTree(this.selectTreeKey);

          //修改入口，要记录当前课程方的ID
          this.roleId = params.id;
          setTimeout(() => {
            this.form.setFieldsValue(formData);
          }, 100);
        } else {
          this.form.resetFields();
        }
      },


      //隐藏
      handleCancel() {
        this.visible = false;
        this.$emit("closeForm");
      },

      //提交表单
      handleSubmit(e) {
        e.preventDefault();
        this.form.validateFields((err, value) => {
          //清除左右空格及数据赋值处理
            value.roleName = value.roleName? value.roleName.trim(): ''
            value.roleDesc = value.roleDesc? value.roleDesc.trim(): ''
            value.perms = this.roleReqList!=null?this.roleReqList:this.selectTreeKeys
            this.commitFlag = false
          if (value)
          //校验通过
            if (!err) {
              let tempValue = analysisAddress(value);
                tempValue.id = this.roleId
                this.updateRole(tempValue);

            }
        });
      },


      //修改角色
      updateRole(value) {
        delete value.permIds
        role.updateRole(value).then(res => {
          this.$message.success("修改成功");
          this.$emit("addRole", null);
          this.handleCancel();
        });
      },

      //查询下拉选择全部权限的集合
      getAllPermissionList() {
        permission.getAllPermissionList().then(res => {
          // 删除跟权限
          for (var i = 0, len = res.data.length; i < len; i++) {
            if (res.data[i].key === "0") {
              res.data.splice(i, 1)
            }
          }
          this.allPermissionList = res.data;
        })
      },

      //点击复选框

      onCheck(checkedKeys, info,checkedNodes) {
        this.selectTreeKey = checkedKeys
        this.roleReqList = this.selectTreeKey.concat(info.halfCheckedKeys);

      },
    },

    created() {
      //查询下拉选择权限的集合
      this.getAllPermissionList()
    },
  };
</script>
<style lang="scss" scoped>
  @import "src/config/var";

  .check-tree-value {
    color: red;
  }
</style>